import styled from '@emotion/styled';

const StyledText = styled('div')({
  marginTop: 14,
  textAlign: 'center',
  lineHeight: 1
});

export default StyledText;
